import React, { useState, useEffect } from 'react';
import axios from 'axios';
import webservice from '../../../services/webservice';
import { AesDecrypt } from '../../../services/crypto';

const RemoteConfigView = ({ onBack }) => {
  const [configData, setConfigData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchRemoteConfig();
  }, []);

  const fetchRemoteConfig = async () => {
    try {
      const response = await axios.post(`${webservice}api/getRemoteConfig`, {});
      if (response.data.response === 'S') {
        const decryptedData = AesDecrypt(response.data.data);
        if (decryptedData) {
          setConfigData(JSON.parse(decryptedData));
        }
      }
    } catch (error) {
      console.error('Error fetching remote config:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="remote-config-container">
      {loading ? (
        <div className="d-flex justify-content-center py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      ) : (
        <div className="row">
          {configData && configData.length > 0 ? (
            configData.map((item, index) => {
              const platformName = item.platform ? item.platform.charAt(0).toUpperCase() + item.platform.slice(1) : 'Unknown';
              return (
                <div
                  className="col-xl-4 col-lg-6 col-md-6 col-sm-12"
                  key={index}
                  style={{
                    padding: "12px",
                  }}
                >
                  <div
                    style={{
                      height: "100%",
                      background: "#ffffff",
                      border: "1px solid #E5E7EB",
                      borderRadius: "16px",
                      overflow: "hidden",
                      boxShadow: "0 4px 15px rgba(15, 23, 42, 0.06)",
                      transition: "all 0.25s ease",
                      display: "flex",
                      flexDirection: "column",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-3px)";
                      e.currentTarget.style.boxShadow =
                        "0 10px 25px rgba(15, 23, 42, 0.10)";
                      e.currentTarget.style.borderColor = "#D6E4FF";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow =
                        "0 4px 15px rgba(15, 23, 42, 0.06)";
                      e.currentTarget.style.borderColor = "#E5E7EB";
                    }}
                  >
                    {/* Header */}
                    <div
                      style={{
                        padding: "20px 20px 16px",
                        borderBottom: "1px solid #F1F5F9",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "flex-start",
                          gap: "12px",
                        }}
                      >
                        <div style={{ minWidth: 0 }}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              flexWrap: "wrap",
                            }}
                          >
                            <h4
                              style={{
                                margin: 0,
                                fontSize: "17px",
                                fontWeight: "700",
                                color: "#111827",
                                lineHeight: "1.4",
                              }}
                            >
                              {platformName} Mobile App
                            </h4>

                            <span
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                padding: "4px 9px",
                                background: "#EEF2FF",
                                color: "#4F46E5",
                                border: "1px solid #E0E7FF",
                                borderRadius: "6px",
                                fontSize: "10px",
                                fontWeight: "700",
                                textTransform: "uppercase",
                                letterSpacing: "0.3px",
                              }}
                            >
                              {item.environment || "N/A"}
                            </span>
                          </div>

                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "6px",
                              marginTop: "7px",
                              color: "#64748B",
                              fontSize: "12px",
                            }}
                          >
                            <i
                              className="fa fa-code-branch"
                              style={{
                                fontSize: "11px",
                                color: "#94A3B8",
                              }}
                            />

                            <span>
                              Version:{" "}
                              <strong style={{ color: "#475569" }}>
                                {item.version || "1.0"}
                              </strong>
                            </span>
                          </div>
                        </div>

                        {/* Status */}
                        <span
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "6px",
                            flexShrink: 0,
                            padding: "6px 11px",
                            borderRadius: "20px",
                            fontSize: "11px",
                            fontWeight: "700",
                            background: item.isActive ? "#ECFDF5" : "#FEF2F2",
                            color: item.isActive ? "#059669" : "#DC2626",
                            border: `1px solid ${item.isActive ? "#A7F3D0" : "#FECACA"
                              }`,
                          }}
                        >
                          <span
                            style={{
                              width: "6px",
                              height: "6px",
                              borderRadius: "50%",
                              background: item.isActive ? "#10B981" : "#EF4444",
                            }}
                          />

                          {item.isActive ? "Active" : "Inactive"}
                        </span>
                      </div>
                    </div>

                    {/* Body */}
                    <div
                      style={{
                        padding: "18px 20px",
                        flex: 1,
                      }}
                    >
                      <div style={{ padding: "20px" }}>
                        {(() => {
                          const booleans = Object.entries(item.config || {}).filter(([_, v]) => typeof v === 'boolean');
                          const strings = Object.entries(item.config || {}).filter(([_, v]) => typeof v === 'string');

                          return (
                            <>
                              {booleans.length > 0 && (
                                <div style={{ marginBottom: "18px" }}>
                                  <div
                                    style={{
                                      fontSize: "11px",
                                      fontWeight: "700",
                                      color: "#94A3B8",
                                      textTransform: "uppercase",
                                      letterSpacing: "0.5px",
                                      marginBottom: "8px",
                                    }}
                                  >
                                    Features
                                  </div>

                                  {booleans.slice(0, 4).map(([key, value], index) => (
                                    <div
                                      key={key}
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        padding: "9px 0",
                                        borderBottom: index < 3 && index < booleans.length - 1 ? "1px dashed #E2E8F0" : "none",
                                      }}
                                    >
                                      <span
                                        style={{
                                          fontSize: "13px",
                                          color: "#475569",
                                        }}
                                      >
                                        {key.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
                                      </span>

                                      <span
                                        style={{
                                          fontSize: "11px",
                                          fontWeight: "700",
                                          padding: "4px 8px",
                                          borderRadius: "5px",
                                          background: value ? "#ECFDF5" : "#F1F5F9",
                                          color: value ? "#059669" : "#94A3B8",
                                        }}
                                      >
                                        {value ? "Active" : "Off"}
                                      </span>
                                    </div>
                                  ))}
                                </div>
                              )}

                              {/* Extra Information */}
                              <div
                                style={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  alignItems: "center",
                                  gap: "7px",
                                  background: "#F8FAFC",
                                  border: "1px solid #F1F5F9",
                                  padding: "9px 11px",
                                  borderRadius: "8px",
                                  fontSize: "11px",
                                  color: "#64748B",
                                }}
                              >
                                {strings.length > 0 ? (
                                  <>
                                    {strings.slice(0, 2).map(([key, value], index) => (
                                      <React.Fragment key={key}>
                                        <span
                                          style={{
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            maxWidth: "200px"
                                          }}
                                          title={`${key}: ${value}`}
                                        >
                                          {key.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}: <span style={{ color: "#334155", fontWeight: "500" }}>{value}</span>
                                        </span>
                                        {(index < 1 && index < strings.length - 1) && (
                                          <span style={{ color: "#CBD5E1" }}>|</span>
                                        )}
                                      </React.Fragment>
                                    ))}
                                  </>
                                ) : (
                                  <span>No extra settings</span>
                                )}
                              </div>
                            </>
                          );
                        })()}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div
              className="col-12"
              style={{
                padding: "12px",
              }}
            >
              <div
                style={{
                  background: "#FFFFFF",
                  border: "1px solid #E5E7EB",
                  borderRadius: "16px",
                  padding: "60px 20px",
                  textAlign: "center",
                  boxShadow: "0 4px 15px rgba(15, 23, 42, 0.05)",
                }}
              >
                <div
                  style={{
                    width: "50px",
                    height: "50px",
                    margin: "0 auto 14px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "#F1F5F9",
                    borderRadius: "50%",
                    color: "#94A3B8",
                  }}
                >
                  <i
                    className="fa fa-cog"
                    style={{
                      fontSize: "20px",
                    }}
                  />
                </div>

                <p
                  style={{
                    margin: 0,
                    color: "#64748B",
                    fontSize: "14px",
                    fontWeight: "500",
                  }}
                >
                  No configuration data found.
                </p>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default RemoteConfigView;
